import microthemesData from '@/components/data/microthemes-pyq.json';

export function slugify(value) {
  return value
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

const slugCounts = new Map();

export const pyqEntries = microthemesData.map((question, index) => {
  const theme = slugify(question.Microtheme) || 'mains-question';
  const baseSlug = `${theme}-upsc-gs${question.GS}-${question.Year}`;
  const occurrence = (slugCounts.get(baseSlug) || 0) + 1;
  slugCounts.set(baseSlug, occurrence);

  return {
    ...question,
    id: index,
    slug: occurrence === 1 ? baseSlug : `${baseSlug}-${occurrence}`,
  };
});

export function getPyqBySlug(slug) {
  return pyqEntries.find((entry) => entry.slug === slug);
}
